import type { SelectOption } from '@/components/SearchableSelect'
import type { MonthSummaryItem } from '@/services/giftCards'
import { incomeAllocationMonthsRange } from '@/utils/allocationFormat'
import { reportMonthLabel } from '../distribution-waterfall/waterfallJeStatus'

export function mergeGiftCardMonthSelectOptions(
  apiMonths: MonthSummaryItem[],
  asOf?: Date,
): SelectOption[] {
  const byMonth = new Map(apiMonths.map((entry) => [entry.report_month, entry]))

  return incomeAllocationMonthsRange(asOf).map((reportMonth) => {
    const entry = byMonth.get(reportMonth)
    return {
      id: reportMonth,
      label: reportMonthLabel(reportMonth),
      status: entry?.status ?? 'incomplete',
      hint: entry?.hint ?? undefined,
    }
  })
}
